interface RatingPillProps {
  rating: number
  reviews: number
}

export function RatingPill({ rating, reviews }: RatingPillProps) {
  const tier =
    rating >= 95 ? 'overwhelmingly-positive' :
    rating >= 85 ? 'very-positive' :
    rating >= 75 ? 'positive' :
    rating >= 60 ? 'mixed' : 'negative'

  const label =
    rating >= 95 ? 'Overwhelmingly Positive' :
    rating >= 85 ? 'Very Positive' :
    rating >= 75 ? 'Mostly Positive' :
    rating >= 60 ? 'Mixed' : 'Negative'

  return (
    <span className={`cg-rating ${tier}`} title={`${label} · ${reviews.toLocaleString()} reviews`}>
      <span className="cg-rating-pct">{rating}%</span>
      <span className="cg-rating-meta">({(reviews / 1000).toFixed(0)}k)</span>
    </span>
  )
}
